/**
 * Item Map helpers for dishes created by Sales Name Check's Add new (spec D4,
 * §10.4). GET /api/recipes rows carry
 *   added_from_sales: { pos_name, plates, period_from, period_to } | null
 * (period_* are 'YYYY-MM-DD' strings: the pg DATE parser returns them as text).
 */
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** An added dish whose recipe is not confirmed yet: orange, and not counted by Finish. */
export const isPendingAddedFromSales = (recipe) => Boolean(
  recipe && recipe.added_from_sales && recipe.status !== 'confirmed',
);

/** 'Added from sales · 96 plates · Sep' */
export const addedFromSalesLabel = (origin) => {
  if (!origin) return '';
  const plates = Math.round(Number(origin.plates || 0));
  const parts = ['Added from sales', `${plates.toLocaleString('en-IN')} plate${plates === 1 ? '' : 's'}`];
  const m = /^(\d{4})-(\d{2})/.exec(String(origin.period_from || ''));
  if (m) parts.push(MONTHS[Number(m[2]) - 1]);
  return parts.join(' · ');
};
